export enum PoNumberActionTypes {
  SetPoNumber = '[PO Number] Set PO Number',
  SetPoNumberSuccess = '[PO Number | Cart] Set PO Number Success'
}

interface SetPoNumberPayload {
  poNumber: string;
}

export class SetPoNumber {
  readonly type = PoNumberActionTypes.SetPoNumber;

  constructor(public payload: SetPoNumberPayload) {
  }
}
